// src/extensions/ResizableTableCell.js

import { TableCell } from 'tiptap-extensions'

export default class ResizableTableCell extends TableCell {
  get schema() {
    return {
      ...super.schema,
      attrs: {
        ...super.schema.attrs,
        colwidth: { default: null },
        style: { default: null },
      },
      parseDOM: [
        {
          tag: 'td',
          getAttrs: (dom) => ({
            colwidth: dom.getAttribute('width') || null,
            style: dom.getAttribute('style') || null,
          }),
        },
      ],
      toDOM: (node) => [
        'td',
        {
          style: node.attrs.style || 'border: 1px solid black; padding: 5px;',
          width: node.attrs.colwidth ? `${node.attrs.colwidth}px` : 'auto',
        },
        0,
      ],
    }
  }
}
